module.exports = __webpack_public_path__ + "img/offer-jackpots.9d2e367d.svg";